export default __webpack_public_path__ + "static/media/meme_coin_up_white.bd1cbd48.svg";